<template>
  <b-col
    cols="12"
    lg="6"
    class="mb-4"
  >
    <b-card>
      <template #header>
        <h4 class="mb-0">
          🛍️ Mais Vendidos - Produtos
        </h4>
      </template>
      <div class="produtos-mais-vendidos-section">
        <div
          v-if="loading"
          class="text-center p-4"
        >
          <b-spinner />
          <p class="mt-2 mb-0">
            Carregando produtos mais vendidos...
          </p>
        </div>
        <div
          v-else-if="produtosMaisVendidos.length === 0"
          class="text-center text-muted p-4"
        >
          <feather-icon
            icon="ShoppingBagIcon"
            size="48"
            class="text-muted mb-3"
          />
          <h5>Nenhum produto encontrado</h5>
          <p>Os dados dos produtos mais vendidos aparecerão aqui quando disponíveis.</p>
        </div>
        <div
          v-else
          class="produtos-scroll-container"
        >
          <div
            v-for="(produto, index) in produtosMaisVendidos"
            :key="`${produto.produto_id || produto.id}-${produto.variacao || ''}-${index}`"
            class="d-flex align-items-center justify-content-between mb-2 p-2 rounded border produto-card"
            style="transition: all 0.2s ease;"
            @mouseover="$event.target.style.transform='translateY(-1px)'"
            @mouseleave="$event.target.style.transform='translateY(0)'"
          >
            <div class="d-flex align-items-center flex-grow-1">
              <div class="position-relative mr-2">
                <b-avatar
                  :src="`https://api.dicebear.com/7.x/shapes/svg?seed=${produto.produto_nome}`"
                  size="40"
                  class="border"
                  variant="light"
                />
                <b-badge
                  :variant="getTopProdutoBadgeVariant(index)"
                  pill
                  class="position-absolute top-badge"
                  style="top: -5px; right: -5px; font-size: 10px;"
                >
                  {{ index + 1 }}º
                </b-badge>
              </div>
              <div class="flex-grow-1">
                <h6 class="mb-1 font-weight-bold">
                  {{ produto.nome || produto.produto_nome }}
                </h6>
                <small class="text-muted d-block">
                  SKU: {{ produto.produto_id || 'N/A' }}
                </small>
                <small class="text-muted d-block">
                  <span class="text-info">{{ produto.quantidade_vendida || 0 }} vendidos</span>
                  <span class="mx-1">•</span>
                  <span class="text-warning">{{ produto.pedidos_unicos || 0 }} pedidos</span>
                </small>
              </div>
            </div>
            <div
              v-if="produto.variacao"
              class="ml-3"
            >
              <b-badge
                variant="light-primary"
                class="px-2 py-1"
              >
                Variação: {{ produto.variacao }}
              </b-badge>
            </div>
          </div>
        </div>
      </div>
    </b-card>
  </b-col>
</template>

<script>
import {
  BCol, BCard, BSpinner, BAvatar, BBadge,
} from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import { formatarMoeda } from '../services/dashboardService'

export default {
  name: 'TopProdutos',
  components: {
    BCol,
    BCard,
    BSpinner,
    BAvatar,
    BBadge,
    FeatherIcon,
  },
  props: {
    produtosMaisVendidos: {
      type: Array,
      required: true,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatarMoeda(valor) {
      return formatarMoeda(valor)
    },

    getTopProdutoBadgeVariant(index) {
      if (index === 0) return 'warning' // 1º lugar - dourado
      if (index === 1) return 'secondary' // 2º lugar - prata
      if (index === 2) return 'danger' // 3º lugar - bronze
      return 'success' // demais posições - verde para produtos
    },
  },
}
</script>

<style scoped>
.produtos-mais-vendidos-section {
  min-height: 200px;
}

.produtos-scroll-container {
  max-height: 400px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

.produtos-scroll-container::-webkit-scrollbar {
  width: 8px;
}

.produtos-scroll-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.produtos-scroll-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}

.produtos-scroll-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.produto-card {
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.produto-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background-color: #f8f9fa;
}

.top-badge {
  font-weight: bold;
  font-size: 10px;
}

/* Dark Mode */
.dark-layout {
  .produto-card {
    background-color: #283046;
    border-color: #3b4253;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  }

  .produto-card:hover {
    background-color: #2c3a50;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
  }
}
</style>
